import find from "lodash/find";
import startsWith from "lodash/startsWith";
import { ContentSelectionPhoto } from "../../types/customization/content";
import { SelectionPhoto, SelectionState } from "../../types/selection/selection";
import { getVariableByEnv } from "../variableByEnv";

export const THUMBNAIL_FIT_SIZE = 300;
export const FULL_MIN_SIZE = 1000;

const FOTOM_URL = getVariableByEnv("REACT_APP_FOTOM_URL");

export function convertSelectionPhotoToContent(
  selectionPhoto: SelectionPhoto
): ContentSelectionPhoto {
  if (!selectionPhoto.fotomKey) {
    throw new Error("Photo not uploaded to Fotom");
  }

  return {
    fotomKey: selectionPhoto.fotomKey,

    key: selectionPhoto.key,

    height: selectionPhoto.height,
    width: selectionPhoto.width,

    provider: selectionPhoto.provider,
    providerRef: selectionPhoto.providerRef,
  };
}

export function addSelectionPhotoToSelection(
  selectionPhoto: SelectionPhoto,
  selection: SelectionState
): void {
  const existingPhoto = find(selection.photos, ({ key }) => key === selectionPhoto.key);
  if (existingPhoto) {
    return;
  }

  selection.photos.push(selectionPhoto);
}

export function removeSelectionPhotoFromSelection(
  selectionPhoto: SelectionPhoto,
  selection: SelectionState
): void {
  selection.photos = selection.photos.filter(
    (photo) =>
      photo.key !== selectionPhoto.key &&
      `${photo.provider}-${photo.providerRef}` !== selectionPhoto.key
  );
}

export function imageUrlFromSelectionPhoto(
  selectionPhoto: SelectionPhoto,
  size: "original" | "full" | "thumbnail"
): string {
  const {
    fotomKey,
    height: { value: height },
    providerPictureUrl,
    providerThumbnailUrl,
    width: { value: width },
  } = selectionPhoto;

  if (size === "original") {
    if (fotomKey && startsWith(fotomKey, "https://images.unsplash.com")) {
      return fotomKey;
    }

    if (fotomKey && !startsWith(fotomKey, "fake")) {
      return `${FOTOM_URL}/photos/${fotomKey}.jpg`;
    }

    if (providerPictureUrl) {
      return providerPictureUrl;
    }
  } else if (size === "full") {
    if (fotomKey && startsWith(fotomKey, "https://images.unsplash.com")) {
      return fotomKey.replace(/w=[0-9]+/, `w=${FULL_MIN_SIZE}`);
    }

    if (fotomKey && !startsWith(fotomKey, "fake")) {
      if (height <= FULL_MIN_SIZE || width <= FULL_MIN_SIZE) {
        return `${FOTOM_URL}/photos/${fotomKey}.jpg`;
      }

      return `${FOTOM_URL}/photos/min/${FULL_MIN_SIZE}/${fotomKey}.jpg`;
    }

    if (providerPictureUrl) {
      return providerPictureUrl;
    }
  } else if (size === "thumbnail") {
    if (providerThumbnailUrl) {
      return providerThumbnailUrl;
    }

    if (fotomKey && startsWith(fotomKey, "https://images.unsplash.com")) {
      return fotomKey.replace(/w=[0-9]+/, `w=${THUMBNAIL_FIT_SIZE}`);
    }

    if (fotomKey && !startsWith(fotomKey, "fake")) {
      return `${FOTOM_URL}/photos/fit/${THUMBNAIL_FIT_SIZE}/${fotomKey}.jpg`;
    }
  }

  throw new Error(`Can't find an imageUrl. Fotom key: ${fotomKey || "undefined"}, size: ${size}`);
}
